import React from 'react'
import { Form, Input, Select, Upload, Button } from 'antd'
import PropTypes from 'prop-types'
import { UploadOutlined } from '@ant-design/icons'
import { EnFormItem } from '../../shared/LocalizedFields'

const ProverbsCollectionsForm = ({
  form,
  status,
  titleKaz,
  titleRus,
  titleEng,
  proverbs,
  selectedProverbs
}) => {
  const FormItem = Form.Item
  return (
    <Form form={form} layout="vertical" hideRequiredMark>
      <FormItem
        key="status"
        label="Статус документа"
        name="status"
        rules={[
          {
            required: true,
            message: `Пожалуйста, выберите статус`
          }
        ]}
        initialValue={status}
      >
        <Select placeholder="Выберите статус" mode="single">
          <Select.Option key="active" value="active">
            Активный
          </Select.Option>
          <Select.Option key="inactive" value="inactive">
            Скрытый
          </Select.Option>
        </Select>
      </FormItem>
      <FormItem
        key="titleKaz"
        label="Название (каз)"
        name="titleKaz"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название на казахском`
          }
        ]}
        initialValue={titleKaz}
      >
        <Input placeholder="Название (каз)" />
      </FormItem>
      <FormItem
        key="titleRus"
        label="Название (рус)"
        name="titleRus"
        rules={[
          {
            required: true,
            message: `Пожалуйста, введите название на русском`
          }
        ]}
        initialValue={titleRus}
      >
        <Input placeholder="Название (рус)" />
      </FormItem>
      <EnFormItem
        name="titleEng"
        label="Название (англ)"
        initialValue={titleEng}
      />
      <FormItem
        key="proverbs"
        label="Загадки"
        name="proverbs"
        rules={[
          {
            required: false,
            message: `Пожалуйста, выберите загадки`
          }
        ]}
        initialValue={selectedProverbs?.map(item => (item ? item?.id : item))}
      >
        <Select
          placeholder="Выберите загадки"
          mode="multiple"
          showSearch
          optionFilterProp="children"
        >
          {proverbs?.map(item => (
            <Select.Option key={item.id} value={item.id}>
              {item.text} - {item.type}
            </Select.Option>
          ))}
        </Select>
      </FormItem>
      <FormItem
        name="verticalImageFile"
        label="Вертикальная картинка"
        valuePropName="file"
        getValueFromEvent={e => e.file}
        rules={[
          {
            required: false,
            message: 'Пожалуйста, загрузите вертикальную картинку'
          }
        ]}
      >
        <Upload beforeUpload={() => false}>
          <Button icon={<UploadOutlined />}>
            Выберите вертикальную картинку
          </Button>
        </Upload>
      </FormItem>
      <FormItem
        name="horizontalImageFile"
        label="Горизонтальная картинка"
        valuePropName="file"
        getValueFromEvent={e => e.file}
        rules={[
          {
            required: false,
            message: 'Пожалуйста, загрузите горизонтальную картинку'
          }
        ]}
      >
        <Upload beforeUpload={() => false}>
          <Button icon={<UploadOutlined />}>
            Выберите горизонтальную картинку
          </Button>
        </Upload>
      </FormItem>
    </Form>
  )
}

ProverbsCollectionsForm.propTypes = {
  form: PropTypes.objectOf(PropTypes.any).isRequired
}

export default ProverbsCollectionsForm
